<style>
    dl.brew-info {
        padding: 0 1em 0 1em;
        margin: 0;
    }

    .brew-info dt {
        float: left;
        font-weight: bolder;
        margin-bottom: 0.7em;
    }

    .brew-info dd {
        color: #444;
        margin: 0 0 1rem 0;
        padding-left: 6rem;
        text-align: left;
    }

    .brew-info > div > div > .label {
        color: #444 !important;
        font-weight: bold;
        font-size: 1.2em;
    }

    .ui.breadcrumb.beer-style {
        vertical-align: middle;
        padding: 13px 0 13px 0;
    }

    .sg-temp .highcharts-yaxis-grid .highcharts-grid-line {
        display: none;
    }

    .color-up {
        color: #26a65b;
    }

    .color-down {
        color: #ef4836;
    }

    .color-fix {
        color: #399bff;
    }

    .topstats {
        font-size: 12px;
        margin-left: -5px;
        margin-right: -5px;
        text-shadow: none;
        padding: 12px 0;
        text-align: center;
        margin: 10px 0;
    }

        .topstats .title {
            color: hsl(214, 7%, 47%) !important;
            font-size: 1rem;
        }

            .topstats .title .icon {
                font-size: 15px;
                color: #A6ADB6 !important;
            }

        .topstats h3 {
            font-size: 1.6rem;
            font-weight: bold;
            color: #292b2e;
            line-height: normal;
            margin: 1px 0;
        }

            .topstats h3 small {
                color: #37363e;
            }

        .topstats .diff b {
            font-weight: bold;
        }

        .topstats .diff .icon {
            margin-right: 0 !important;
        }

        .topstats .arrow {
            position: absolute;
            width: 0;
            height: 0;
            top: -18px;
            right: 5px;
            border-style: solid;
            border-width: 0 10px 10px 10px;
            border-color: transparent transparent #fff transparent;
        }

    .topstats-last-reading {
        float: right;
        font-size: .8rem;
        color: #37363e;
        text-decoration: none !important;
    }

    .ui.menu.dashboard-menu {
        box-shadow: none !important;
        border-radius: 0 !important;
    }

    .mobile-stats .ui.list {
        padding: 0 1em 0 1em;
    }

        .mobile-stats .ui.list .item {
            padding: .5em 0 .5em 0;
        }

    .grey-icon {
        color: hsl(214, 7%, 47%) !important;
    }

    .stats-label {
        /*font-size: .9rem !important;*/
        color: #585C5F !important;
    }

    .stats-data {
        /*font-size: .9rem !important;*/
        font-weight: 700;
    }
</style>
<template>
    <div>
        <div class="ui one column very relaxed stackable grid">
            <div class="row">
                <div class="column">
                    <div class="computer-only ui right floated compact borderless tiny menu dashboard-menu">
                        <a class="item" href="#" v-on:click.prevent="toggleRecipe" v-if="showRecipe" title="Hide Recipe">
                            <i class="ui hide icon"></i>
                        </a>
                        <a class="active item" href="#" v-on:click.prevent="toggleRecipe" v-else title="Show Recipe">
                            <i class="ui unhide icon"></i>
                        </a>
                        <a class="item" title="Edit Recipe" :href="urls.edit" v-if="isOwner">
                            <i class="ui pencil icon"></i>
                        </a>
                        <a class="item" :href="urls.export" target="_blank" v-if="isOwner">
                            <i class="ui download icon" title="Export"></i> Export
                        </a>

                        <div class="ui hover dropdown item units">
                            <span v-html="currentDisplayUnits"></span> <i class="dropdown icon"></i>
                            <div class="menu">
                                <div class="item" dava-value="fi" @click="updateDisplayUnits(false, false)">
                                    &deg;F, lb/oz
                                </div>
                                <div class="item" dava-value="fm" @click="updateDisplayUnits(true, false)">
                                    &deg;F, kg/g
                                </div>
                                <div class="item" data-value="cm" @click="updateDisplayUnits(true, true)">
                                    &deg;C, kg/g
                                </div>
                                <div class="item" data-value="ci" @click="updateDisplayUnits(false, true)">
                                    &deg;C, lb/oz
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="tablet-only mobile-only float-right">
                        <div class="ui top right tiny icon dropdown link dashboard-menu">
                            <i class="ellipsis horizontal icon" title="Options"></i>
                            <div class="menu">
                                <a class="item" href="#" v-on:click.prevent="toggleRecipe" v-if="showRecipe" title="Hide Recipe">
                                    <i class="ui hide icon"></i> Hide Recipe
                                </a>
                                <a class="active item" href="#" v-on:click.prevent="toggleRecipe" v-else title="Show Recipe">
                                    <i class="ui unhide icon"></i> Show Recipe
                                </a>
                                <a class="item" :href="urls.edit" v-if="isOwner">
                                    <i class="ui pencil icon" title="Edit Recipe"></i> Edit Recipe
                                </a>
                                <a class="item" :href="urls.export" target="_blank" v-if="isOwner">
                                    <i class="ui download icon" title="Export"></i> Export
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="beer-name">
                        <srm-label :value="brew.specification.color" />
                        {{ brew.recipe.name }}
                    </div>
                    <div class="ui breadcrumb beer-style" v-if="brew.recipe.style">
                        <a class="section" :href="brew.recipe.style.categoryUrl" target="_blank">{{ brew.recipe.style.categoryName }}</a>
                        <div class="divider"> / </div>
                        <a class="section" :href="brew.recipe.style.subCategoryUrl" target="_blank">{{ brew.recipe.style.subCategoryName }}</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="brew-stats ui vertically center aligned divided stackable very relaxed grid">

            <div class="two column row" v-if="stats == null">
                <div class="column">
                    <dl class="brew-info">
                        <dt>Boil Time:</dt>
                        <dd>
                            {{ brew.recipe.boilTime | toMinsDays}}
                        </dd>
                        <dt>Boil Size:</dt>
                        <dd>
                            <liquid-label :value="brew.recipe.boilSize" />
                        </dd>
                        <dt>Batch Size:</dt>
                        <dd>
                            <liquid-label :value="brew.recipe.batchSize" />
                        </dd>
                        <dt>Efficiency:</dt>
                        <dd>{{ brew.recipe.efficiency | percent }}</dd>
                    </dl>
                </div>

                <div class="left aligned column" v-if="device">
                    <div class="ui icon message">
                        <i class="wait icon"></i>
                        <div class="content">
                            <div class="header">
                                <a :href="urls.tilt">
                                    <div class="ui empty circular label" v-bind:class="brew.cssColorName"></div>
                                    {{ device.nickname }}
                                </a>
                            </div>
                            <p>Waiting for data...</p>
                        </div>
                    </div>
                </div>
                <div class="left aligned column" v-else>
                    <div class="ui icon message">
                        <i class="signal icon"></i>
                        <div class="content">
                            <div class="header">
                                No Device Assigned
                            </div>
                            <p v-if="isOwner == true">
                                <a :href="urls.tilt" class="inverted">Assign Tilt Hydrometer</a>
                            </p>
                        </div>
                    </div>
                </div>

            </div>

            <!--Desktop View-->
            <div class="tablet computer only five column row" v-else>
                <div class="column topstats">
                    <span class="title">
                        <i class="half thermometer icon" aria-hidden="true"></i> Temperature
                    </span>
                    <h3>
                        <temp-label :value="stats.latest.temperature" />
                    </h3>

                    <percent-change :value="stats.change.temperaturePercent" :from="stats.prior.created" v-if="isActive" />

                </div>
                <div class="column topstats">
                    <span class="title">
                        <i class="lab icon" aria-hidden="true"></i> Specific Gravity
                    </span>

                    <h3 v-if="stats">{{ stats.latest.specificGravity | formatSGForDisplay }}</h3>

                    <percent-change :value="stats.change.specificGravityPercent" :from="stats.prior.created" :reversed="true" v-if="isActive" />
                </div>
                <div class="column topstats">
                    <span class="title">
                        <i class="bar icon" aria-hidden="true"></i> ABV
                    </span>
                    <h3>
                        <live-abv-label :og="stats.initial.specificGravity" :fg="stats.latest.specificGravity" />
                    </h3>

                    <percent-change :value="stats.change.abvPercent" :from="stats.prior.created" v-if="isActive" />

                </div>
                <div class="column topstats">
                    <span class="title">
                        <i class="percent icon" aria-hidden="true"></i> Attenuation
                    </span>
                    <h3>
                        <live-attn-label :og="stats.initial.specificGravity" :fg="stats.latest.specificGravity" />
                    </h3>

                    <percent-change :value="stats.change.attenuationPercent" :from="stats.prior.created" v-if="isActive" />

                </div>
                <div class="column topstats" v-if="isOwner == true">
                    <span class="title">
                        <i class="users icon" aria-hidden="true"></i> Visitors
                    </span>
                    <h3>{{ stats.latest.viewCount }}</h3>

                    <percent-change :value="stats.change.viewCountPercent" :from="stats.prior.created" v-if="isActive" />

                </div>
            </div>
            <!-- /Desktop View-->
            <!-- Mobile View -->
            <div class="mobile only one column row no-top-padding" s>
                <div class="column" style="padding-top:0 !important; padding-bottom:0!important;" v-if="stats">

                    <table class="ui unstackable very basic table">
                        <tr>
                            <td>
                                <i class="half thermometer icon grey-icon" aria-hidden="true"></i> <span class="stats-label">Temperature:</span>
                            </td>
                            <td class="collapsing right aligned stats-data">
                                <temp-label :value="stats.latest.temperature" />
                            </td>
                            <td class="collapsing right aligned">
                                <percent-change :value="stats.change.temperaturePercent" :from="stats.prior.created" :showLabel="false" v-if="isActive" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i class="lab icon grey-icon" aria-hidden="true"></i> <span class="stats-label">Specific Gravity (SG):</span>
                            </td>
                            <td class="collapsing right aligned stats-data">
                                {{ formatSGForDisplay(stats.latest.specificGravity) }}
                            </td>
                            <td class="collapsing right aligned">
                                <percent-change :value="stats.change.specificGravityPercent" :from="stats.prior.created" :showLabel="false" :reversed="true" v-if="isActive" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i class="bar icon grey-icon" aria-hidden="true"></i> <span class="stats-label">ABV:</span>
                            </td>
                            <td class="collapsing right aligned stats-data">
                                <live-abv-label :og="stats.initial.specificGravity" :fg="stats.latest.specificGravity" />
                            </td>
                            <td class="collapsing right aligned">
                                <percent-change :value="stats.change.abvPercent" :from="stats.prior.created" :showLabel="false" v-if="isActive" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i class="percent icon grey-icon" aria-hidden="true"></i> <span class="stats-label">Attenuation:</span>
                            </td>
                            <td class="collapsing right aligned stats-data">
                                <live-attn-label :og="stats.initial.specificGravity" :fg="stats.latest.specificGravity" />
                            </td>
                            <td class="collapsing right aligned">
                                <percent-change :value="stats.change.attenuationPercent" :from="stats.prior.created" :showLabel="false" v-if="isActive" />
                            </td>
                        </tr>
                        <tr v-if="isOwner == true">
                            <td>
                                <i class="users icon grey-icon" aria-hidden="true"></i> <span class="stats-label">Visitors:</span>
                            </td></td>
                            <td class="collapsing right aligned stats-data">
                                {{ stats.latest.viewCount }}
                            </td>
                            <td class="collapsing right aligned">
                                <percent-change :value="stats.change.viewCountPercent" :from="stats.prior.created" :showLabel="false" v-if="isActive" />
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <!-- /Mobile View -->

            <div class="one column row" style="padding-top:0 !important; ">
                <div class="column">
                    <div class="ui vertically padded grid brew-info">
                        <div class="row">
                            <div class="four wide mobile four wide tablet four wide computer column">
                                <div class="label">Boil Time</div>
                                <div class="value">{{ brew.recipe.boilTime | toMinsDays}}</div>
                            </div>

                            <div class="four wide mobile four wide tablet four wide computer column">
                                <div class="label">Boil Size</div>
                                <div class="value">
                                    <liquid-label :value="brew.recipe.boilSize" />
                                </div>
                            </div>

                            <div class="four wide mobile four wide tablet four wide computer column">
                                <div class="label">Batch Size</div>
                                <div class="value">
                                    <liquid-label :value="brew.recipe.batchSize" />
                                </div>
                            </div>

                            <div class="four wide mobile four wide tablet four wide computer column">
                                <div class="label">Efficiency</div>
                                <div class="value">{{ brew.recipe.efficiency | percent }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import moment from "moment";
    import utils from "../../utils/units";
    import Cookie from "js-cookie";
    import { FormatSGForDisplay } from "../../helpers/recipeDisplayHelpers";
    import { mapState, mapGetters } from 'vuex'

    import LiveAbvLabel from "../../components/LiveAbvLabel";
    import LiveAttnLabel from "../../components/LiveAttnLabel";


    export default {
        data() {
            return {
                currentDisplayUnits: "&deg;F, lb/oz",
                displayUnits: "fi"
            }
        },
        components: {
            LiveAbvLabel,
            LiveAttnLabel
        },
        methods: {
            toggleRecipe,
            updateDisplayUnits,
            refreshBrew,
            formatSGForDisplay
        },
        created() {

        },
        computed: {
            ...mapState(["currentUser", "brew", "stats", "device", "urls", "isActive", "isLoggedIn", "showRecipe"]),
            ...mapGetters(["isOwner", "isMetric", "isCelcius"])
        },
        mounted() {

            this.updateDisplayUnits(this.isMetric, this.isCelcius);

            $(".ui.dropdown.units")
                .dropdown({ on: 'hover' })
                .dropdown("set selected", this.displayUnits);

            $(".ui.dropdown.dashboard-menu").dropdown();

        },
        updated() {
            $(".ui.dropdown.units")
                .dropdown({ on: 'hover' })
                .dropdown("set selected", this.displayUnits);
        }
    }
    // Methods

    function toggleRecipe() {
        this.$store.commit('SET_SHOW_RECIPE', this.showRecipe ? false : true);

        Cookie.set("show-recipe", this.showRecipe, {
            expires: 7
        });
    }

    function updateDisplayUnits(isMetric, isCelcius) {

        if (isCelcius) {
            this.currentDisplayUnits = "&deg;C";
            this.displayUnits = "c";
        } else {
            this.currentDisplayUnits = "&deg;F";
            this.displayUnits = "f";
        }

        if (isMetric) {
            this.currentDisplayUnits += ", kg/g";
            this.displayUnits += "m";
        } else {
            this.currentDisplayUnits += ", lb/oz";
            this.displayUnits = "i";
        }


        this.$store.commit('IS_METRIC', isMetric);
        this.$store.commit('IS_CELCIUS', isCelcius);
    }

    function refreshBrew(event) {
        $(event.target).closest("a").find("i").addClass("fa-spin");

        setTimeout(function () {
            $(event.target).closest("a").find("i").removeClass("fa-spin");
        }, 1000);

        this.$emit("refreshBrew");
    }

    function formatSGForDisplay(val) {
        return FormatSGForDisplay(val);
    }

</script>



// WEBPACK FOOTER //
// src/sections/brew/BrewInfo.vue